import React, { useState, useEffect } from "react";
import { Card, CardBody, CardTitle, Col, Table, Input } from "reactstrap";
import { Eye } from "react-feather";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ToolTip } from "../../AbstractElements";
import { getReportsService } from "./services/report-service";
import { Button } from "react-bootstrap";
import MyPagination from "../pagination";
// import { dummyReports } from "./data/data";

{/*
export const getReportsService = async ({ pageNo = 1, pageSize = 10 }) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const startIndex = (pageNo - 1) * pageSize;
      const endIndex = startIndex + pageSize;
      resolve({
        data: {
          data: {
            documents: dummyReports.slice(startIndex, endIndex),
            count: dummyReports.length,
          },
        },
      });
    }, 500);
  });
};
*/}

const formatDate = (date) => {
  const formatter = new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  return formatter.format(new Date(date));
};

const Reports = () => {
  const { t } = useTranslation();
  const [reports, setReports] = useState([]);
  const [openTooltipId, setOpenTooltipId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [totalEntries, setTotalEntries] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, [currentPage, entriesPerPage]);

  const getData = async () => {
    setLoading(true);
    try {
      const data = {
        pageNo: currentPage,
        pageSize: entriesPerPage,
      };
      const res = await getReportsService(data);
      if (res?.data?.data) {
        setReports(res.data.data.documents || []);
        setTotalEntries(res.data.data.count || 0);
      }
    } catch (error) {
      console.error("Error fetching reports:", error);
    } finally {
      setLoading(false);
    }
  };

  const totalPages = Math.ceil(totalEntries / entriesPerPage);

  const toggleViewTooltip = (id) =>
    setOpenTooltipId(openTooltipId === id ? null : id);

  const handleEntriesChange = (e) => {
    const newEntriesPerPage = parseInt(e.target.value);
    setEntriesPerPage(newEntriesPerPage);
    setCurrentPage(1);
  };

  return (
    <Card>
      <CardBody>
        <div className="d-flex justify-content-between">
          <CardTitle tag="h3" className="mb-3 tw-font-bold">
            {t("Test Reports")}
          </CardTitle>
          <Button
            variant="primary"
            onClick={() => navigate("/add-report")}
            className="tw-w-fit tw-h-fit"
          >
            {t("Add Report")}
          </Button>
        </div>

        <Col sm="12" lg="12" xl="12">
          <div className="rounded table-responsive">
            <Table className="mb-0 table-center table-bordered table-hover">
              <thead>
                <tr>
                  <th>{t("Patient Name")}</th>
                  <th>{t("Test")}</th>
                  <th>{t("NAKBHO Health ID")}</th>
                  <th>{t("Date")}</th>
                  <th className="text-center">{t("View")}</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="5" className="text-center">
                      {t("Loading...")}
                    </td>
                  </tr>
                ) : reports.length > 0 ? (
                  reports.map((report) => (
                    <tr key={report._id}>
                      <td>{report.patient?.name || "N/A"}</td>
                      <td>
                        {report.event_data?.content?.test_detail
                          ?.lab_report_title || "N/A"}
                      </td>
                      <td>{report.patient?.health_id?.match(/.{1,4}/g).join(" ") || "N/A"}</td>
                      <td>
                        {formatDate(
                          report.event_data?.content?.test_detail
                            ?.date_of_examination || report.createdAt
                        )}
                      </td>
                      <td className="text-center">
                        <button
                          id={`ViewToolTip-${report._id}`}
                          onClick={() => navigate(`/view-report/${report._id}`)}
                          className="success-action-button me-1"
                        >
                          <li className="fa fa-eye" style={{ fontSize: "18px" }}></li>
                        </button>
                        <ToolTip
                          attrToolTip={{
                            placement: "top",
                            isOpen: openTooltipId === report._id,
                            target: `ViewToolTip-${report._id}`,
                            toggle: () => toggleViewTooltip(report._id),
                          }}
                        >
                          {t("View")}
                        </ToolTip>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      {t("No reports available")}
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Col>

        <div className="mt-3 d-md-flex align-items-center justify-content-between">
          <div className="show-entries d-flex align-items-center">
            <span style={{ whiteSpace: "nowrap", fontSize: "14px" }}>
              {t("Show")}&nbsp;
            </span>
            <Input
              type="select"
              value={entriesPerPage}
              onChange={handleEntriesChange}
              bsSize="sm"
              style={{ display: "inline", width: "auto" }}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={20}>20</option>
            </Input>
            <span style={{ whiteSpace: "nowrap", fontSize: "14px" }}>
              &nbsp;{t("entries")}
            </span>
          </div>

          <div>
            <MyPagination
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default Reports;
